import { Component, Input, OnInit } from '@angular/core';
import * as UI_CONSTANTS from '@app/vehicle-registration/vehicle-registration.constants';
import * as _ from 'lodash';
import { commonId } from 'app/core/constants/common-constants';
import { ReservationService } from '@app/core/services/reservation.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ANALYTICS, ANALYTICS_TRACK_LINKS } from '@app/shared/constants/app.constants';
import { addAnalyticsTrackLinkToATag } from '@app/shared/utils/utils.object';
import { RoutingService } from '@app/core/services/routing.service';
import { DScribeService } from '@app/core/services/dscribe.service';
import { Reservation } from '@app/core/models/reservation.model';

@Component({
  selector: 'dtr-hub-app-vehicle-registration',
  templateUrl: './vehicle-registration.component.html',
  styleUrls: ['./vehicle-registration.component.scss']
})
export class VehicleRegistrationComponent implements OnInit {
  @Input() campus: string;
  @Input() isAddFlow = true;
  @Input() reservation: Reservation;
  @Input() dscbDetails: any;
  @Input() expanded = true;
  @Input() allSectionsOnFile = false;

  UI_CONSTANTS;
  vehicleRegistrationData: any;
  commonData: any;
  vehicleCount: any;
  edit = false;
  minVehicleCount = 0;
  maxVehicleCount = 0;
  isValet: boolean;

  private learnMoreLinkText: string;

  constructor(
    public routingService: RoutingService,
    public dscribeService: DScribeService,
    public reservationService: ReservationService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.UI_CONSTANTS = UI_CONSTANTS;
    this.vehicleRegistrationData = _.find(this.dscbDetails, function (module) {
      return module.id === UI_CONSTANTS.moduleId;
    });
    this.commonData = _.find(this.dscbDetails, function (module) {
      return module.id === commonId;
    });

    this.maxVehicleCount = (this.reservation.vehicleParking && this.reservation.vehicleParking.vehicleMaxLimit) ? 
      (this.reservation.vehicleParking.vehicleMaxLimit) : 0;
    this.vehicleCount = this.isVehicleInfoAvailable(this.reservationService.roomcheckinPayload)
      ? this.reservationService.roomcheckinPayload.vehicleParking.vehicleCount
      : this.minVehicleCount;

    this.reservationService.vehicleCount = this.vehicleCount;
    this.isValet = this.reservationService.isValetParkSet(this.reservation);
  }

  isVehicleInfoAvailable = (payload: any): boolean => {
    return (
      payload &&
      payload.vehicleParking &&
      payload.vehicleParking.vehicleCount > 0
    );
  };

  decreaseVehicleCount() {
    this.vehicleCount = this.vehicleCount === this.minVehicleCount ? this.minVehicleCount : this.vehicleCount - 1;
    this.reservationService.roomcheckinPayload.vehicleParking = {
      vehicleCount: this.vehicleCount
    };
    this.reservationService.vehicleCount = this.vehicleCount;
  }

  increaseVehicleCount() {
    this.vehicleCount = this.vehicleCount === this.maxVehicleCount ? this.maxVehicleCount : this.vehicleCount + 1;
    this.reservationService.roomcheckinPayload.vehicleParking = {
      vehicleCount: this.vehicleCount
    };
    this.reservationService.vehicleCount = this.vehicleCount;
  }

  // All get methods
  get vehicleRegistrationHeading(): string {
    return this.vehicleRegistrationData?.sections?.title;
  }

  get vehicleRegistrationDescription(): string {
    return this.vehicleRegistrationData?.sections?.description;
  }

  get vehicleLearnMoreDescription(): string {
    return this.vehicleRegistrationData?.descriptions[0].sections.additionalInformationText;
  }

  get vehicleCantEditDescription(): string {
    return this.vehicleRegistrationData?.descriptions[1].sections.additionalInformationText;
  }

  get registeredVehicleDescription(): string {
    return this.vehicleRegistrationData?.descriptions[1].sections.description.replace('{{noOfRegisteredVehicles}}', ' ' + this.vehicleCount);
  }

  get vehicleQuestionText(): string {
    return this.vehicleRegistrationData.descriptions[0].sections.questionText;
  }

  get vehicleRegistrationAdd(): string {
    return this.commonData.descriptions[0].sections.addLabel;
  }

  get learnMoreLink() {
    const color = this.isAddFlow ? '#D04901' : '#B73C00';
    if (this.learnMoreLinkText && this.learnMoreLinkText.length > 0) {
      // We save the RRN Terms Conditions to the component so we don't have rebuild it everytime
      // angular is auto-sanitizing the contents, which removes the analyticsTrackLink
      return this.sanitizer.bypassSecurityTrustHtml(`<strong style="color: ${color}">${this.learnMoreLinkText}</strong>`);
    }
    const termsAndConditionsBody = this.vehicleRegistrationData.descriptions[0].sections.learnMoreLinkText;
    const trackLinkConfig = ANALYTICS_TRACK_LINKS.filter((conf) => {
      return conf.element === 'rrnTermsConditions';
    })[0];
    const updatedTermsAndConditions = addAnalyticsTrackLinkToATag(termsAndConditionsBody, trackLinkConfig, ANALYTICS);
    this.learnMoreLinkText = updatedTermsAndConditions;
    // angular is auto-sanitizing the contents, which removes the analyticsTrackLink
    return this.sanitizer.bypassSecurityTrustHtml(`<strong style="color: ${color}">${this.learnMoreLinkText}</strong>`);
  }

  get vehicleLearnMoreLinkText(): string {
    return this.vehicleRegistrationData.descriptions[0].sections.learnMoreLinkText;
  }

}
